import { TabPanel } from '@mui/lab';
import { Input } from '../../../../../shared/components/Input';
import { InputDate } from '../../../../../shared/components/InputDate';
import { SelectAutoCompleteComponent } from '../../../../../shared/components/SelectAutoCompleteComponent';
import { SelectAutoCompleteOptions } from '../../../../../shared/types/selectAutoComplete';
import Box from '@mui/material/Box';
import {
  InputSelect,
  Item,
} from '../../../../../shared/components/InputSelect';
import Typography from '@mui/material/Typography';
import { InputCEP } from '../../../../../shared/components/InputCEP';
import { Checkbox, FormControlLabel } from '@mui/material';

interface TabCadastroProps {
  values: any;
  handleChange: any;
  handleBlur: any;
  touched: any;
  setFieldValue: any;
  cfopOptions: Item[];
  errors: any;
  customerOptions: SelectAutoCompleteOptions[];
  sellerOptions: SelectAutoCompleteOptions[];
  duploClick?: boolean;
  clonar: any;
  handleSearchCustomer: (value: string) => void;
  handleSearchSeller: (value: string) => void;
  handleAutoCompleteSelected: (value: SelectAutoCompleteOptions) => void;
  handleAutoCompleteSelectedSeller: (value: SelectAutoCompleteOptions) => void;
  handleZipCode: (value: string) => void;
}

export const TabCadastro = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  customerOptions,
  sellerOptions,
  duploClick,
  clonar,
  handleSearchCustomer,
  handleAutoCompleteSelected,
  handleSearchSeller,
  handleAutoCompleteSelectedSeller,
  cfopOptions,
  setFieldValue,
  handleZipCode,
}: TabCadastroProps) => {
  return (
    <TabPanel value={'1'}>
      <fieldset disabled={duploClick}>
        <Box className={'grid grid-cols-9 pt-4 gap-6'}>
          <Input
            disabled={true}
            label='Número'
            name='cadastro.numero'
            className={'col-span-3'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.cadastro?.vnd_id && errors?.cadastro?.vnd_id
                ? errors?.cadastro?.vnd_id
                : ''
            }
            hasError={!!(touched?.cadastro?.vnd_id && errors?.cadastro?.vnd_id)}
            value={(clonar === 'S') ? '' : values?.cadastro?.vnd_id ?? ''}
          />
          <InputDate
            label='Data *'
            name='cadastro.data_emissao'
            className={'col-span-3'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.cadastro?.data_emissao && errors?.cadastro?.data_emissao
                ? errors?.cadastro?.data_emissao
                : ''
            }
            hasError={
              !!(
                touched?.cadastro?.data_emissao && errors?.cadastro?.data_emissao
              )
            }
            value={values?.cadastro?.data_emissao ?? ''}
          />
          <InputDate
            label='Data Entrega*'
            name='cadastro.data_entrega'
            className={'col-span-3'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.cadastro?.data_entrega && errors?.cadastro?.data_entrega
                ? errors?.cadastro?.data_entrega
                : ''
            }
            hasError={
              !!(
                touched?.cadastro?.data_entrega && errors?.cadastro?.data_entrega
              )
            }
            value={values?.cadastro?.data_entrega ?? ''}
          />

          <SelectAutoCompleteComponent
            label={'Cliente'}
            name={'cadastro.cli_id'}
            size='small'
            className='col-span-5'
            handleBlur={handleBlur}
            value={values?.cadastro?.cli_nome ?? ''}
            options={customerOptions}
            handleSearch={(value: string) => handleSearchCustomer(value)}
            onSelectValue={handleAutoCompleteSelected}
            error={
              errors?.cadastro?.cli_nome
                ? errors?.cadastro?.cli_nome
                : ''
            }
            hasError={
              !!(
                errors?.cadastro?.cli_nome
              )
            }
          />
          
          <InputSelect
            label='Grupo Tributário'
            name='cadastro.grupo_tributario'
            size='small'
            items={cfopOptions}
            handleBlur={handleBlur}
            className={'col-span-4'}
            handleChange={handleChange}
            helperText={
              touched?.cadastro?.grupo_tributario &&
                errors?.cadastro?.grupo_tributario
                ? errors?.cadastro?.grupo_tributario
                : ''
            }
            error={
              !!(
                touched?.cadastro?.grupo_tributario &&
                errors?.cadastro?.grupo_tributario
              )
            }
            value={values?.cadastro?.grupo_tributario ?? ''}
            disabled={duploClick}
          />
          <SelectAutoCompleteComponent
            label={'Vendedor'}
            className='col-span-5'
            size='small'
            value={values?.cadastro?.vend_nome ?? ''}
            name={'cadastro.vend_nome'}
            options={sellerOptions}
            handleSearch={(value: string) => handleSearchSeller(value)}
            onSelectValue={handleAutoCompleteSelectedSeller}
            error={
              errors?.cadastro?.vend_nome
                ? errors?.cadastro?.vend_nome
                : ''
            }
            hasError={
              !!(
                errors?.cadastro?.vend_nome
              )
            }
          />
          <Input
            label='Tabela de preço'
            name='cadastro.tabela_preco'
            size='small'
            className={'col-span-4'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              errors?.cadastro?.tabela_preco
                ? errors?.cadastro?.tabela_preco
                : ''
            }
            hasError={
              !!(
                errors?.cadastro?.tabela_preco
              )
            }
            value={values?.cadastro?.tabela_preco ?? ''}
          />
          {/* [24/09 - item 1 do teste de 23/09] De onde este documento veio.
              Sempre presente e sempre desabilitado: vazio num pedido digitado do zero,
              preenchido numa devolução ou num pedido gerado por Ordem de Serviço.

              O TEXTO vem do banco (`vnd_origem`), não de dedução: pedido de OS também
              tem `vnd_origemID` preenchido, então chamar de "devolução" tudo que tem id
              de origem faria todo pedido vindo de OS se declarar devolução. */}
          <Input
            label='Origem'
            name='cadastro.vnd_origemID'
            size='small'
            className={'col-span-4'}
            disabled={true}
            handleBlur={handleBlur}
            handleChange={handleChange}
            value={
              values?.cadastro?.vnd_origemID
                ? `${values?.cadastro?.vnd_origem || 'Documento'} ${values.cadastro.vnd_origemID}`
                : ''
            }
          />
          {/* [REMOVIDO 22/09/2026] O campo Observação saiu daqui: ele e o da guia
              "Dados adicionais" gravavam no MESMO `cadastro.observacao`, ou seja, na
              mesma coluna VENDA.vnd_obs - dois campos editando um dado só, em guias
              diferentes. Ficou o da guia nova, que preserva maiúsculas e minúsculas
              (este usava o <Input> compartilhado, que força caixa alta no VALOR) e
              cabe 700 caracteres. */}
          <Typography className='col-span-8' variant='h6'>
            Dados de Entrega
          </Typography>
          <InputCEP
            disabled={true}
            label='CEP'
            className='col-span-2'
            name='cli_cep'
            handleBlur={handleBlur}
            error={errors.cli_cep ? errors.cli_cep : ''}
            hasError={!!(errors.cli_cep)}
            value={values?.cadastro?.cli_cep ?? ''}
          />
          <Input
            disabled={true}
            label='Estado'
            className='col-span-1'
            name='cli_uf'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={touched.cli_uf && errors.cli_uf ? errors.cli_uf : ''}
            hasError={!!(touched.cli_uf && errors.cli_uf)}
            value={values?.cadastro?.cli_uf ?? ''}
          />
          <Input
            disabled={true}
            label='Cidade'
            className='col-span-3'
            name='cli_cidade'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={touched.cli_cidade && errors.cli_cidade ? errors.cli_cidade : ''}
            hasError={!!(touched.cli_cidade && errors.cli_cidade)}
            value={values?.cadastro?.cli_cidade ?? ''}
          />
          <Input
            disabled={true}
            label='Bairro'
            className='col-span-3'
            name='cli_bairro'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={touched.cli_bairro && errors.cli_bairro ? errors.cli_bairro : ''}
            hasError={!!(touched.cli_bairro && errors.cli_bairro)}
            value={values?.cadastro?.cli_bairro ?? ''}
          />
          <Input
            disabled={true}
            label='Endereço'
            className='col-span-4'
            name='cli_endereco'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={errors.cli_endereco ? errors.cli_endereco : ''}
            hasError={!!(errors.cli_endereco)}
            value={values?.cadastro?.cli_endereco ?? ''}
          />
          <Input
            disabled={true}
            label='Numero'
            className='col-span-2'
            name='cli_numero'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={touched.cli_numero && errors.cli_numero ? errors.cli_numero : ''}
            hasError={!!(touched.cli_numero && errors.cli_numero)}
            value={values?.cadastro?.cli_numero ?? ''}
          />
          <Input
            disabled={true}
            label='Complemento'
            className='col-span-3'
            name='cli_complemento'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={touched.cli_complemento && errors.cli_complemento ? errors.cli_complemento : ''}
            hasError={!!(touched.cli_complemento && errors.cli_complemento)}
            value={values?.cadastro?.cli_complemento ?? ''}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={values?.cadastro?.endereco_alternativo == 'S' || false}
                name='cadastro.endereco_alternativo'
                onChange={(event) =>
                  setFieldValue(
                    'cadastro.endereco_alternativo',
                    event.target.checked ? 'S' : 'N'
                  )
                }
              />
            }
            className='col-span-3'
            label='Endereço alternativo'
          />
          {values?.cadastro?.endereco_alternativo == 'S' && (
            <>
              <InputCEP
                label='CEP'
                className='col-start-1 col-span-2'
                name='entrega.cep'
                handleBlur={handleBlur}
                handleChange={handleZipCode}
                error={errors.entrega?.cep ? errors.entrega?.cep : ''}
                hasError={!!(errors.entrega?.cep)}
                value={values?.entrega?.cep ?? ''}
              />
              <Input
                label='Estado'
                className='col-start-1'
                name='uf'
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={touched.entrega?.uf && errors.entrega?.uf ? errors.entrega?.uf : ''}
                hasError={!!(touched.entrega?.uf && errors.entrega?.uf)}
                value={values?.entrega?.uf ?? ''}
              />
              <Input
                label='Cidade'
                className='col-span-3'
                name='entrega.cidade'
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={touched.entrega?.cidade && errors.entrega?.cidade ? errors.entrega?.cidade : ''}
                hasError={!!(touched.entrega?.cidade && errors.entrega?.cidade)}
                value={values?.entrega?.cidade ?? ''}
              />
              <Input
                label='Bairro'
                className='col-span-4'
                name='entrega.bairro'
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={touched.entrega?.bairro && errors.entrega?.bairro ? errors.entrega?.bairro : ''}
                hasError={!!(touched.entrega?.bairro && errors.entrega?.bairro)}
                value={values?.entrega?.bairro ?? ''}
              />
              <Input
                label='Endereço'
                className='col-span-4'
                name='entrega.endereco'
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={errors.entrega?.endereco ? errors.entrega?.endereco : ''}
                hasError={!!(errors.entrega?.endereco)}
                value={values?.entrega?.endereco ?? ''}
              />
              <Input
                label='Numero'
                className='col-span-2'
                name='entrega.numero'
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={touched.entrega?.numero && errors.entrega?.numero ? errors.entrega?.numero : ''}
                hasError={!!(touched.entrega?.numero && errors.entrega?.numero)}
                value={values?.entrega?.numero ?? ''}
              />
              <Input
                label='Complemento'
                className='col-span-2'
                name='entrega.complemento'
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={touched.entrega?.complemento && errors.entrega?.complemento ? errors.entrega?.complemento : ''}
                hasError={!!(touched.entrega?.complemento && errors.entrega?.complemento)}
                value={values?.entrega?.complemento ?? ''}
              />
            </>
          )}
        </Box>
      </fieldset>
    </TabPanel>
  );
};
